import { FC } from 'react'
import Loading from '../components/common/loading/Loading'
import SettingForm from '../components/settings/SettingForm'
import Page from '../layout/Main/Page'
import { settingsApi } from '../services/settings'

const SettingsPage: FC = () => {
  const { data: settings } = settingsApi.useGetSettingsQuery({})

  return (
    <Page
      header={{
        title: `Settings`,
        subTitle: 'Set up the import and update of products',
      }}
    >
      {!settings ? <Loading /> : <SettingForm defaultState={settings} />}
    </Page>
  )
}

export default SettingsPage
